import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { VideoRecordingIcon } from "../VideoRecordingIcon";

export function SkillsAssessmentAlreadyCompletedFromOnboardingStep() {
  return (
    <Stack spacing={4}>
      <Stack alignItems="center">
        <VideoRecordingIcon sx={{ fontSize: "64px" }} />
      </Stack>

      <Text sx={{ lineHeight: "24px" }}>
        You&apos;ve already completed the video assessment! Continue to add your payment
        information.
      </Text>
    </Stack>
  );
}
